module.exports = __webpack_public_path__ + "img/ai-6.03752f2.png";